export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4764.1850ece3.jpg";